/** `amount` is in minor units — the API sends 999 for £9.99. */
export const formatAmount = (
  amount: number,
  currency: string,
  locale: string,
): string =>
  new Intl.NumberFormat(locale === "zh" ? "zh-HK" : "en-GB", {
    style: "currency",
    currency: currency.toUpperCase(),
  }).format(amount / 100);
